









































import Vue from 'vue'
import { defaultPosterImage, checkIcon } from '../../helper/constants'
export default Vue.extend({
  props: {
    post: {
      type: Object
    },
    categoryId: {
      type: String
    },
    completed: {
      type: Boolean,
      default: false
    },
    available: {
      type: Boolean,
      default: true
    },
    templateId: String
  },
  computed: {
    posterImage(): string {
      return this.post.posterImage || defaultPosterImage
    },
    productId(): string {
      return this.post.productId
    },
    postDescription(): string {
      return this.post.description && this.post.description.length > 75
        ? this.post.description.substring(0, 75)
        : this.post.description
    }
  },
  data() {
    return {
      checkIcon
    }
  },
  methods: {
    openPost() {
      if (this.available) {
        this.$router.push({
          name: 'post-overview',
          params: {
            id: this.productId,
            category_id: this.categoryId,
            post_id: this.post.id
          },
          query: {
            template_id: this.templateId
          }
        })
      }
    }
  }
})
